import { render, staticRenderFns } from "./active-history-visits.view.vue?vue&type=template&id=c5603a5e&"
import script from "./active-history-visits.view.vue?vue&type=script&lang=js&"
export * from "./active-history-visits.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports